

























import _ from 'lodash';
import { ComponentInternalInstance, defineComponent, getCurrentInstance, reactive, watch } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import smh from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import { IS_PRIVATE } from '@/common/constant/platform';
type NotificationMsgSetting = {
  authorityAndSettingMsg: boolean;
  shareMsg: boolean;
  esignMsg: boolean;
  securityMsg: boolean;
};
export default defineComponent({
  name: 'NotificationSetting',
  setup() {
    // 当前组件
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const { $store } = currComponent.proxy;
    const notificationMsgSetting = reactive<NotificationMsgSetting>({
      authorityAndSettingMsg: true,
      shareMsg: true,
      esignMsg: true,
      securityMsg: true,
    });
    const reportNotificationMsg = (msgName: string, msgState: boolean) => {
      reporter.report('management_notification', {
        management_notification_type: msgName,
        management_notification_checkstate: msgState,
      });
    };
    const saveNotificationMsg = async () => {
      let change = false;
      if (notificationMsgSetting.authorityAndSettingMsg !== $store.getters.authorityAndSettingMsg) {
        change = true;
        reportNotificationMsg('news_authority', notificationMsgSetting.authorityAndSettingMsg);
      }
      if (notificationMsgSetting.shareMsg !== $store.getters.shareMsg) {
        change = true;
        reportNotificationMsg('news_link', notificationMsgSetting.shareMsg);
      }
      if (notificationMsgSetting.esignMsg !== $store.getters.esignMsg) {
        change = true;
        reportNotificationMsg('news_partner', notificationMsgSetting.esignMsg);
      }
      if (!change) {
        return;
      }
      try {
        await smh.userAPI.updateSettingConfig({
          receiveMessageConfig: {
            authorityAndSettingMsg: notificationMsgSetting.authorityAndSettingMsg,
            shareMsg: notificationMsgSetting.shareMsg,
            esignMsg: notificationMsgSetting.esignMsg,
            securityMsg: !IS_PRIVATE,
            // 默认为true
            userManageMsg: true,
            // 默认为true
            quotaAndRenewMsg: !IS_PRIVATE, // 默认为true
          },
        });

        $store.commit('SET_USER_SETTING', {
          authorityAndSettingMsg: notificationMsgSetting.authorityAndSettingMsg,
          shareMsg: notificationMsgSetting.shareMsg,
          esignMsg: notificationMsgSetting.esignMsg,
        });
      } catch (e) {
        logger.ui.debug('updateSettingConfig fail', e);
        tips.error(i18n_t('设置变更失败，请重试'));
      }
    };
    const onNotificationChange = _.debounce(
      () => {
        // 消息通知变更保存
        saveNotificationMsg();
      },
      2000,
      {
        leading: true,
      },
    );
    watch(
      () => $store.getters.authorityAndSettingMsg,
      val => {
        notificationMsgSetting.authorityAndSettingMsg = val;
      },
    );
    watch(
      () => $store.getters.shareMsg,
      val => {
        notificationMsgSetting.shareMsg = val;
      },
    );
    watch(
      () => $store.getters.esignMsg,
      val => {
        notificationMsgSetting.esignMsg = val;
      },
    );
    watch(notificationMsgSetting, () => {
      onNotificationChange();
    });

    // 消息通知初始化
    notificationMsgSetting.authorityAndSettingMsg = $store.getters.authorityAndSettingMsg;
    notificationMsgSetting.shareMsg = $store.getters.shareMsg;
    notificationMsgSetting.esignMsg = $store.getters.esignMsg;
    return {
      notificationMsgSetting,
    };
  },
});
